<div class="flex">
  <div
    [ngClass]="
      iohShowFilter && iohLevelLabel !== 'level-1'
        ? 'ioh-filter'
        : 'no-ioh-filter'
    "
  >
    <ioh-csx-level
      [level]="0"
      [iohShowFilter]="iohShowFilter"
      [ngClass]="iohAppService.iohLevelUpdate$() === 0 ? 'D-Block' : 'D-none'"
      [ngStyle]="loading() ? { visibility: 'hidden' } : {}"
      [iohSelectedTerminal]="iohSelectedTerminal"
      (iohTerminalChange)="onTerminalChange($event)"
      [iohLevelLabel]="iohLevelLabel"
      (iohLevelLabelChange)="onLevelChange($event)"
      [queryParams]="queryParams"
    ></ioh-csx-level>

    <ioh-csx-level
      [ngClass]="iohAppService.iohLevelUpdate$() === 1 ? 'D-Block' : 'D-none'"
      [level]="1"
      [iohShowFilter]="iohShowFilter"
      [iohSelectedTerminal]="iohSelectedTerminal"
      (iohTerminalChange)="onTerminalChange($event)"
      [iohLevelLabel]="iohLevelLabel"
      (iohLevelLabelChange)="onLevelChange($event)"
      [queryParams]="queryParams"
    ></ioh-csx-level>

    <ioh-csx-level
      [ngClass]="iohAppService.iohLevelUpdate$() === 2 ? 'D-Block' : 'D-none'"
      [level]="2"
      [queryParams]="queryParams"
      [iohShowFilter]="iohShowFilter"
      [iohLevelLabel]="iohLevelLabel"
      (iohLevelLabelChange)="onLevelChange($event)"
    ></ioh-csx-level>

    <div class="ioh-preloadingimage"></div>
  </div>
  <div
    *ngIf="!loading()"
    [ngClass]="iohAppService.iohLevelUpdate$() === 0 ? 'D-none' : 'D-Block'"
  >
    <ioh-csx-filter
      [level]="iohAppService.iohLevelUpdate$()"
      (showFilterChange)="showFilterChange($event)"
    ></ioh-csx-filter>
  </div>
</div>

<div #mapHost data-ioh-map-host [ngStyle]="mapHostStyle()" [class.ioh-map-embedded]="iohMapService.activeMapSlot() === 'level1'">
  <ioh-map
    [iohLevelLabel]="iohLevelLabel"
    [iohShowFilter]="iohShowFilter"
    [queryParams]="queryParams"
  ></ioh-map>
</div>
<p-toast key="systemerror" position="top-center" class="ioh-custom-toast" />
<!-- <p-toast key="equipmentApiError" [life]="5000"  position="top-center" class="ioh-custom-toast" /> -->
<div *ngIf="isApiFailed">
  <p-message [escape]="false"></p-message>
</div>
